import React from "react";

function TagPill({ children }) {
  if (!children) return null;
  return <span className="text-xs px-2 py-1 rounded border bg-secondary">{children}</span>;
}

export default TagPill;
